import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pari } from '../../../models/pari.model';
import { ConfigService } from '../../../services/config/config.service';
import { sprintf } from '../../../functions/format-strings.function';
import { ActionBtn } from '../../../models/overlay-loader.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ticket-preview',
  imports: [TranslateModule],
  templateUrl: './ticket-preview.component.html',
  styleUrl: './ticket-preview.component.scss'
})
export class TicketPreviewComponent {
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Input() pari: Partial<Pari> = {}
  @Input() ticketData!: string[];
  @Input() ticketActions!: ActionBtn[];

  constructor(private configService: ConfigService){ }

  get raceShortNameFormat() {
      return sprintf(
        this.configService.raceShortNameFormat || '',
        this.pari?.meeting?.id ?? 0,
        this.pari.race?.id ?? 0
      );
  }

  onCloseDialog() {
    this.closeModal.emit(true)
  }
}
